import "./Content.css";

export default function Content({ children, style, className }) {
  return (
    <div style={style} className={"content " + (className ? className : "")}>
      {children}
    </div>
  );
}
